// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__28gIx","img":"Image_img__nmHgn","skeleton":"Image_skeleton__38Y23"};